module.exports = __webpack_public_path__ + "img/landing.bcbd1c91.jpg";